import { Component } from '@angular/core';
import { PlatformAppContext } from '@/app/platform/platform-context/platform-app-context';

@Component({
    selector: 'external-url-page',
    templateUrl: './external-url-page.component.html',
    styleUrls: ['./external-url-page.component.scss'],
    host: {
        class: 'dock-y'
    },
    standalone: false
})
export class ExternalUrlPageComponent {
  constructor(readonly appContext: PlatformAppContext) {}
}
